var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSavings = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9979 20.6647H19.8306C18.8179 20.6647 17.9973 19.844 17.9973 18.8314V17.498C17.9973 16.4854 18.8179 15.6647 19.8306 15.6647H22.9979V14.8314C22.9979 14.3454 22.8046 13.8787 22.4613 13.5347C22.1173 13.1914 21.6506 12.998 21.1646 12.998C18.8559 12.998 14.1399 12.998 11.8313 12.998C11.3453 12.998 10.8786 13.1914 10.5346 13.5347C10.1913 13.8787 9.99792 14.3454 9.99792 14.8314V21.498C9.99792 21.984 10.1913 22.4507 10.5346 22.7947C10.8786 23.138 11.3453 23.3314 11.8313 23.3314H21.1646C21.6506 23.3314 22.1173 23.138 22.4613 22.7947C22.8046 22.4507 22.9979 21.984 22.9979 21.498V20.6647ZM22.9979 16.6647V19.6647H19.8306C19.3706 19.6647 18.9973 19.2914 18.9973 18.8314V17.498C18.9973 17.038 19.3706 16.6647 19.8306 16.6647H22.9979ZM20.1646 17.498C20.5326 17.498 20.8313 17.7967 20.8313 18.1647C20.8313 18.5327 20.5326 18.8314 20.1646 18.8314C19.7966 18.8314 19.4979 18.5327 19.4979 18.1647C19.4979 17.7967 19.7966 17.498 20.1646 17.498Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2232 12.3316H21.1646C21.2919 12.3316 21.4186 12.3416 21.5432 12.3603L21.8592 11.6816C21.9759 11.4316 21.8679 11.1343 21.6179 11.0176L17.3879 9.04492C17.1379 8.92826 16.8406 9.03692 16.7239 9.28692L16.3659 10.0543L18.5659 11.0796C19.0526 11.3069 19.3092 11.8269 19.2232 12.3316Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2812 12.3309H18.5339C18.6379 12.0843 18.5293 11.7976 18.2846 11.6836L14.0546 9.71094C13.8046 9.59427 13.5073 9.70294 13.3906 9.95294L12.2812 12.3309Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSavings);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/savings.4099ca86f015f088c0983f0d02ad6de5.svg";